import useApiServices from './useApiServices';
import { globalAdminUrl } from './globalApi';
//
/**
 * @module AdminServiceService
 * @returns  it return All DataSource Apis
 */

const JourneyService = {
  SaveJourneyTemplate: (credential, token) =>
    useApiServices().postApi(
      `${globalAdminUrl}/journey/save-journey-as-template`,
      credential,
      token
    ),

  LoadTemplateDropDown: (token) =>
    useApiServices().getApi(`${globalAdminUrl}/journey/template-name/list`, token),

  JourneyTemplateList: (credential, token) =>
    useApiServices().postApi(`${globalAdminUrl}/journey/journey-template/list`, credential, token),

  JourneyTemplateCopy: (credential, token) =>
    useApiServices().postApi(`${globalAdminUrl}/journey/journey-template/copy`, credential, token),

  JourneyTemplateView: (credential, token) =>
    useApiServices().postApi(`${globalAdminUrl}/journey/journey-template/view`, credential, token)
};

export default JourneyService;
